module.exports = __webpack_public_path__ + "assets/img/logo-wxbook-new.434b9b9b.svg";